import angular from 'angular';

import api from '../../components/api-service';
import { feconIsacIntegrationStates_configFn } from './feconIsacIntegration.states';
import { ProductFeconIsacIntegrationDelegateService } from './ProductFeconIsacIntegrationDelegate.service';

const componentModule = angular
  .module('product.fecon-isac-integration', [
    api
  ])
  //.service('AuthIsacApiService', AuthIsacApiService)
  .service('ProductFeconIsacIntegrationDelegate', ProductFeconIsacIntegrationDelegateService)
  .config(feconIsacIntegrationStates_configFn)

  .name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/isac-integration/index.js